import React from "react";

import TableHeader from "../common/TableHeader";
import TableBody from "../common/TableBody";

const DailySalaryList = ({
  data,
  totals,
  missingRate,
  formatDateFa,
  formatMoney,
}) => {
  const columns = [
    {
      path: "attendance_date",
      label: "تاریخ روز",
      content: (row) => (
        <div className="daily-salary-date-cell">
          <strong>{formatDateFa(row.attendance_date)}</strong>
          <small dir="ltr">{String(row.attendance_date || "").slice(0, 10)}</small>
        </div>
      ),
    },
    { path: "entry_year", label: "سمستر" },
    {
      path: "subjects",
      label: "مضامین همان روز",
      content: (row) => {
        const items = String(row.subjects || "")
          .split(" | ")
          .map((s) => s.trim())
          .filter(Boolean);
        if (!items.length) return "—";
        return (
          <div className="daily-salary-subjects" title={row.subjects || ""}>
            {items.map((subject, idx) => (
              <span key={`${subject}-${idx}`} className="daily-salary-subject-chip">
                {subject}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      path: "present_count",
      label: "حاضر",
      content: (row) => (
        <span className="daily-salary-num tone-ok">{row.present_count || 0}</span>
      ),
    },
    {
      path: "substitute_count",
      label: "جایگزین",
      content: (row) => (
        <span className="daily-salary-num tone-info">
          {row.substitute_count || 0}
        </span>
      ),
    },
    {
      path: "absent_count",
      label: "غایب",
      content: (row) => (
        <span className="daily-salary-num tone-warn">
          {row.absent_count || 0}
        </span>
      ),
    },
    {
      path: "paid_session_count",
      label: "کردت قابل پرداخت",
      content: (row) => (
        <span className="daily-salary-num tone-pay">
          {row.paid_session_count || 0}
        </span>
      ),
    },
    {
      path: "salary_per_hour",
      label: "نرخ",
      content: (row) => {
        const rate = Number(row.salary_per_hour || 0);
        if (!rate) {
          return <span className="daily-salary-rate-missing">ثبت نشده</span>;
        }
        return formatMoney(rate);
      },
    },
    {
      path: "day_earn_gross",
      label: "معاش روز",
      content: (row) => {
        const rate = Number(row.salary_per_hour || 0);
        const paid = Number(row.paid_session_count || 0);
        if (!rate && paid > 0) {
          return (
            <span
              className="daily-salary-earn-cell is-blocked"
              title="نرخ ثبت نشده"
            >
              0 $ (بدون نرخ)
            </span>
          );
        }
        return (
          <strong className="daily-salary-earn-cell">
            {formatMoney(row.day_earn_gross)}
          </strong>
        );
      },
    },
    {
      path: "payable_amount",
      label: "قابل پرداخت",
      content: (row) => {
        const rate = Number(row.salary_per_hour || 0);
        const paid = Number(row.paid_session_count || 0);
        if (!rate && paid > 0) {
          return <span className="daily-salary-rate-missing">0 $</span>;
        }
        return (
          <span className="daily-salary-num tone-pay">
            {formatMoney(row.day_earn_gross)}
          </span>
        );
      },
    },
  ];

  const benefit = Number(totals?.total_benefit || 0);
  const lectureEarn = Number(totals?.day_earn_gross || 0);
  const grandTotal = Number(
    totals?.with_benefits != null
      ? totals.with_benefits
      : lectureEarn + benefit
  );

  return (
    <div className="table-card daily-salary-table">
      {missingRate ? (
        <p className="daily-salary-table-hint">
          اعداد حاضر/جایگزین درست‌اند؛ مبلغ به‌خاطر نبودن نرخ قرارداد فعلاً صفر است.
        </p>
      ) : (
        <p className="daily-salary-table-hint">
          هر ردیف = یک روز تدریس. معاش روز فقط از جلسات حاضر و جایگزین حساب می‌شود.
        </p>
      )}
      <table>
        <colgroup>
          <col className="col-date" />
          <col className="col-semester" />
          <col className="col-subjects" />
          <col className="col-num" />
          <col className="col-num" />
          <col className="col-num" />
          <col className="col-num" />
          <col className="col-rate" />
          <col className="col-earn" />
          <col className="col-paid" />
        </colgroup>
        <TableHeader
          columns={columns}
          handleSort={() => {}}
          sortColumn={{ path: "attendance_date", order: "desc" }}
        />
        <TableBody data={data} columns={columns} />
        <tfoot>
          {benefit > 0 ? (
            <tr className="daily-salary-benefit-row">
              <td colSpan={3}>امتیازات</td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td>{formatMoney(benefit)}</td>
            </tr>
          ) : null}
          <tr className="row-total">
            <td colSpan={3}>مجموعه</td>
            <td>{totals?.present_count || 0}</td>
            <td>{totals?.substitute_count || 0}</td>
            <td>{totals?.absent_count || 0}</td>
            <td>{totals?.paid_session_count || 0}</td>
            <td />
            <td>{formatMoney(lectureEarn)}</td>
            <td>{formatMoney(grandTotal)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default DailySalaryList;
